












import { Component, Vue, namespace, Watch } from 'nuxt-property-decorator'
import VueScrollTo from 'vue-scrollto'
import { BRANDS_API } from '~/assets/config/api-path'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { filterDate } from '~/assets/filters/date'
import { IMeta } from '~/assets/interfaces/meta'
const pageStore = namespace('page')
const siteStore = namespace('site')

@Component({
  layout: (ctx) => {
    return ctx.$device.isMobileOrTablet ? 'mobile' : 'default'
  },
  components: {
    ComponentPageBrandsIdType1: () =>
      import('~/components/pages/brands/page-brands-id-type-1.vue'),
    ComponentPageBrandsIdType2: () =>
      import('~/components/pages/brands/page-brands-id-type-2.vue'),
  },
  filters: {
    filterDate,
  },
})
export default class pageBrandsIndex extends Vue {
  @siteStore.Getter('getFixedHeaderHeight')
  readonly getFixedHeaderHeight!: number

  private async asyncData({
    $axios,
    route,
    error,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
    error: any
  }) {
    try {
      const response = await $axios.$get(
        BRANDS_API + '/' + route.params._id + '/'
      )

      return {
        content: response,
      }
    } catch (err) {
      error({ statusCode: 404, message: 'Post not found' })
    }
  }

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => void

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  private content: any = {}
  private isLoading: boolean = false

  private get componentName() {
    if (this.content.type) {
      switch (this.content.type) {
        case 'type-1':
          return 'component-page-brands-id-type1'
        case 'type-2':
          return 'component-page-brands-id-type2'
        default:
          return null
      }
    }
    return null
  }

  private created(): void {
    if (this.content.meta) {
      this.setMeta(this.content.meta)
    }
    if (this.content.breadcrumbs) {
      this.setBreadcrumbs(this.content.breadcrumbs)
    }
  }

  private async getContent() {
    const response = await this.$axios.$get(
      BRANDS_API + '/' + this.$route.params._id,
      {
        params: this.$route.query,
      }
    )
    this.content = response
  }

  @Watch('$route')
  private async routeHandler() {
    this.isLoading = true
    await this.getContent()
    this.isLoading = false
    let offset = -1 * (24 + this.getFixedHeaderHeight)
    if (this.$device.isMobileOrTablet) {
      offset = -48
    }
    const el = this.$refs.wrapper as HTMLElement
    if (el) {
      VueScrollTo.scrollTo(el, { offset })
    }
  }
}
